import api from '@services/api'

export default {
  list(axios, params, query, config) {
    return api.get(axios, '/machines/:machine_id/reports', params, query, config)
  },
}
